(() => {
  const dialog = document.querySelector('#sz-sms-dialog');
  const configNode = document.querySelector('#sz-sms-config');
  if (!dialog || !configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = window.Shopify?.routes?.root || '/';
  const agree = dialog.querySelector('[data-sz-sms-agree]');
  const phone = dialog.querySelector('#sz-sms-phone');
  const save = dialog.querySelector('[data-sz-sms-save]');
  const decline = dialog.querySelector('[data-sz-sms-decline]');
  const cancel = dialog.querySelector('[data-sz-sms-cancel]');
  const error = dialog.querySelector('[data-sz-sms-error]');
  const wording = dialog.querySelector('[data-sz-sms-wording]').textContent.trim();
  let pending = null, busy = false;
  function normalized(value) {
    const v = value.trim().replace(/[\s().-]/g, '');
    if (/^\d{10}$/.test(v)) return '+1' + v;
    if (/^1\d{10}$/.test(v)) return '+' + v;
    return /^\+[1-9]\d{7,14}$/.test(v) ? v : '';
  }
  function controls() { save.disabled = busy || !agree.checked; decline.disabled = busy; cancel.disabled = busy; agree.disabled = busy; phone.disabled = busy; }
  function dismiss() {
    if (busy) return;
    const task = pending; pending = null; dialog.close();
    if (task) { const e = new Error('Consent review cancelled'); e.name = 'AbortError'; task.reject(e); }
  }
  window.szSmsConsentReview = () => {
    if (pending) return pending.promise;
    agree.checked = false; error.textContent = ''; controls();
    let resolve, reject;
    const promise = new Promise((a, b) => { resolve = a; reject = b; });
    pending = {promise, resolve, reject}; dialog.showModal();
    return promise;
  };
  async function record(consented) {
    if (busy || !pending || (consented && !agree.checked)) return;
    const number = normalized(phone.value);
    if (consented && !number) { error.textContent = config.invalidPhone; phone.focus(); return; }
    busy = true; controls(); error.textContent = '';
    try {
      const attributes = {
        sz_sms_consent_v1: consented ? 'yes' : 'no',
        sz_sms_consent_text: wording,
        sz_sms_consent_version: config.version,
        sz_sms_consent_phone: consented ? number : '',
        sz_sms_consent_recorded_utc: new Date().toISOString(),
        sz_sms_consent_source: 'Cart consent before checkout',
        sz_sms_consent_theme: String(config.theme)
      };
      const response = await fetch(root + 'cart/update.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes})});
      if (!response.ok) throw Error(config.error);
      const cart = await response.json();
      for (const [key, value] of Object.entries(attributes)) if ((cart.attributes?.[key] || '') !== value) throw Error(config.error);
      const task = pending; pending = null; dialog.close(); task.resolve(consented);
    } catch { error.textContent = config.error; }
    finally { busy = false; controls(); }
  }
  document.addEventListener('click', event => { if (!(event.target instanceof Element)) return; if (event.target.closest('[data-sz-sms-review]')) { event.preventDefault(); void window.szSmsConsentReview().catch(() => {}); } });
  agree.addEventListener('change', controls);
  save.addEventListener('click', () => void record(true));
  decline.addEventListener('click', () => void record(false));
  cancel.addEventListener('click', dismiss);
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.querySelector('[data-sz-sms-terms-link]').addEventListener('click', event => { event.preventDefault(); const terms = dialog.querySelector('#sz-sms-terms'); terms.open = true; terms.scrollIntoView({block:'nearest'}); });
})();
